import { Cell } from 'tableTypes'
import { Link } from 'react-router-dom'
import React from 'react'
import classNames from 'classnames'

type SimpleCellProps = {
    cell: Cell
}

type TextGroupProps = {
    group: Array<string>
}

const TextGroup: React.FC<TextGroupProps> = ({ group }) => {
    return (
        <>
            {group.map((text) => (
                <div key={text} className="textGroup">
                    {text}
                </div>
            ))}
        </>
    )
}

const SimpleCell: React.FC<SimpleCellProps> = ({ cell }) => {
    const { isBold, isPercentage, text, linkPath } = cell

    let cellText: React.ReactNode = 'N/A' // Default for empty cells

    if (Array.isArray(text) && text.length > 0) {
        cellText = <TextGroup group={text} />
    } else if (text) {
        cellText = linkPath ? <Link to={linkPath}>{text}</Link> : text
    }

    return (
        <span
            className={classNames('simpleCell', 'font-16', {
                isBold,
                percentage: text && isPercentage
            })}
        >
            {cellText}
        </span>
    )
}

export default SimpleCell
